import { TextField } from "@mui/material"
import { DynInputProps } from ".."
import { useCallback } from "react"
import { formatarCNPJ, formatarCPF, formatarCPFCNPJ, formatarInputValorMonetário, formatarTelefone } from "../../../helpers/masks"

export default function DynTextField({
    spec,
    field,
    getFieldState
}: DynInputProps) {

    const { onChange, value } = field.field

    const filterValue = useCallback((value: string) => {
        const mascara = spec.mask

        if (!mascara) return value
        if (mascara === "cpf") return formatarCPF(value)
        if (mascara === "cnpj") return formatarCNPJ(value)
        if (mascara === "cpf_cpnj") return formatarCPFCNPJ(value)
        if (mascara === "telefone") return formatarTelefone(value)
        if (mascara === "monetario_BRL") return formatarInputValorMonetário(value)
    }, [spec])

    return (
        <TextField
            required={spec.required}
            value={value}
            label={spec.label}
            variant="outlined"
            margin="normal"
            fullWidth
            onChange={(e) => onChange(filterValue(e.target.value))}
            error={getFieldState(spec.name).invalid}
            helperText={getFieldState(spec.name).error?.message || ""}
        />
    )
}